import { useState } from "react";
import { LayoutDashboard, ClipboardList, Users, CarTaxiFront, MapPinned, Route, QrCode } from "lucide-react";
import { DashboardShell } from "@/components/DashboardShell";
import { FleetOverview } from "@/components/fleet/FleetOverview";
import { BookingsPanel } from "@/components/fleet/BookingsPanel";
import { DriversPanel } from "@/components/fleet/DriversPanel";
import { VehiclesPanel } from "@/components/fleet/VehiclesPanel";
import { LiveMapPanel } from "@/components/fleet/LiveMapPanel";
import { ShiftReportPanel } from "@/components/fleet/ShiftReportPanel";
import { PostersPanel } from "@/components/fleet/PostersPanel";

const ITEMS = [
  { key: "overview", label: "Overview", icon: LayoutDashboard, title: "Fleet overview" },
  { key: "live", label: "Live map", icon: MapPinned, title: "Live fleet map" },
  { key: "shifts", label: "Shift report", icon: Route, title: "Daily shift & base return report" },
  { key: "bookings", label: "Bookings", icon: ClipboardList, title: "Live bookings" },
  { key: "drivers", label: "Drivers", icon: Users, title: "Drivers" },
  { key: "vehicles", label: "Vehicles", icon: CarTaxiFront, title: "Fleet vehicles" },
  { key: "posters", label: "QR posters", icon: QrCode, title: "QR booking posters" },
];

const PANELS = { overview: FleetOverview, live: LiveMapPanel, shifts: ShiftReportPanel, bookings: BookingsPanel, drivers: DriversPanel, vehicles: VehiclesPanel, posters: PostersPanel };

export default function CompanyDashboard() {
  const [tab, setTab] = useState("overview");
  const Panel = PANELS[tab];
  return (
    <DashboardShell
      roleLabel="Comfort Taxi Fleet Hub"
      title={ITEMS.find((i) => i.key === tab).title}
      subtitle="Manage Comfort Taxi vehicles, drivers and bookings across Port Moresby."
      items={ITEMS}
      active={tab}
      onChange={setTab}
    >
      <Panel />
    </DashboardShell>
  );
}
